import React from 'react';
import PropTypes from 'prop-types';

const fontSizeMapping = {
   title: {
      fontSize: '16px',
      color: '#3a9bdc',
   },
   text: {
      fontSize: '14px',
   },
};

const SampleAdVisualiser = ({ title, textDesc, linkingUrl, displayUrl }) => {
   const allFieldsPresent = title && textDesc && linkingUrl && displayUrl;

   return allFieldsPresent ? (
      <div>
         <a style={fontSizeMapping.title} href={linkingUrl}>{title}</a>
         <p className='mb-1 mt-2' style={fontSizeMapping.text}>{displayUrl}</p>
         <p style={fontSizeMapping.text}>{textDesc}</p>
      </div>
   ) : null;
};

SampleAdVisualiser.propTypes = {
   title: PropTypes.string,
   textDesc: PropTypes.string,
   linkingUrl: PropTypes.string,
   displayUrl: PropTypes.string,
};

SampleAdVisualiser.defaultProps = {
   title: '',
   textDesc: '',
   linkingUrl: '',
   displayUrl: '',
};

export default SampleAdVisualiser;
